import React from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

const ZoomImage = ({ imageUrl }) => {
  return (
    <Zoom>
      <img
        alt="valid insurance card of rider"
        // src={dummy_data.rider_details.license_back_image_url}
        // src={"../images/sample_images/modalpic.png"}
        src={imageUrl}
        width="100%"
        height="400px"
        style={{ objectPosition: "center" }}
        className="rounded-4 object-fit-cover"
      />
    </Zoom>
  );
};

export default ZoomImage;
